// oxlint-disable-next-line typescript/triple-slash-reference -- Includes this ambient declaration in downstream TypeScript projects.
/// <reference path="./monacoInternalWorkers.d.ts" />

import type { Optional } from '@festina-life/core'
import type * as monaco from 'monaco-editor'
import { createWebWorker } from 'monaco-editor/internal/common/workers.js' // we need to import this from the internal workers.js file because that one still exposes moduleId option

import type { LanguageWorker } from '../worker/api'

export class WorkerManager<T extends LanguageWorker<I>, I> {
  private worker: Optional<monaco.editor.MonacoWebWorker<T>>
  private workerClientProxy: Optional<Promise<T>>
  private readonly moduleId: string
  private readonly languageId: string

  constructor(moduleId: string, languageId: string) {
    this.worker = null
    this.workerClientProxy = null
    this.moduleId = moduleId
    this.languageId = languageId
  }

  private getClientproxy(): Promise<T> {
    if (this.workerClientProxy) {
      return this.workerClientProxy
    }

    const worker = createWebWorker<T>({
      // module that exports the create() method and returns an instance
      moduleId: this.moduleId,
      label: this.languageId,
      // passed in to the create() method
      createData: {
        languageId: this.languageId,
      },
    })

    this.worker = worker
    const workerClientProxy = worker.getProxy()
    this.workerClientProxy = workerClientProxy

    return workerClientProxy
  }

  async getLanguageServiceWorker(...resources: monaco.Uri[]): Promise<T> {
    const _client: T = await this.getClientproxy()

    if (this.worker) {
      await this.worker.withSyncedResources(resources)

      return _client
    }

    return _client
  }
}
